import React from 'react';
import { LiliLogo } from '../../assets/svg';
import Icon from '../Icon';
import { useStore } from '../../store';

const PdfPeek = () => {
  const currUser = useStore((state) => state.getSummaryData());
  return (
    <div className='px-2 pt-1.5 bg-bw00 rounded min-h-[33px]'>
      <div className='flex justify-between'>
        <div className='w-[50%] flex flex-col justify-center '>
          <Icon src={LiliLogo} className='w-3' />
          <h1 className='text-[2px]'>Back Account Statement</h1>
        </div>
        <div className='w-5 flex flex-col justify-center '>
          <h1 className='text-[2px]'>Customer Support</h1>
          <p className='text-[1.5px]'>1 (855) 545-4380</p>
          <p className='text-[1.5px]'>Support@lili.co</p>
        </div>
      </div>
      <div className='h-0 border-t-[0.5px] border-action02 my-0.5' />
      <div className='mt-2'>
        <h1 className='text-[2px]'>
          {currUser?.customer?.firstName}
          {currUser?.customer?.lastName}
        </h1>
      </div>
    </div>
  );
};

export default PdfPeek;
